import { routesNames } from '@/core/constants'
import TermoDesentranhamentoRedigir from '@/views/pages/pedido/acessar/documentos/desentranhamento/redigir/TermoDesentranhamentoRedigir.vue'
import TermoDesentranhamentoAssinar from '@/views/pages/pedido/acessar/documentos/desentranhamento/assinar/TermoDesentranhamentoAssinar.vue'
import TermoDesentranhamentoJuntar from '@/views/pages/pedido/acessar/documentos/desentranhamento/juntar/TermoDesentranhamentoJuntar.vue'

export default [
	{
		name: routesNames.PEDIDO.PROCESSO_DIGITAL.DESENTRANHAMENTO.PROCESSO_REDIGIR_TERMO_DESENTRANHAMENTO,
		path: 'redigir',
		component: TermoDesentranhamentoRedigir,
	},
	{
		name: routesNames.PEDIDO.PROCESSO_DIGITAL.DESENTRANHAMENTO.PROCESSO_ASSINAR_TERMO_DESENTRANHAMENTO,
		path: 'assinar',
		component: TermoDesentranhamentoAssinar,
	},
	{
		name: routesNames.PEDIDO.PROCESSO_DIGITAL.DESENTRANHAMENTO.PROCESSO_JUNTAR_TERMO_DESENTRANHAMENTO,
		path: 'juntar',
		component: TermoDesentranhamentoJuntar,
	},
]
